import { Component, OnInit } from "@angular/core";
import { EventService } from "../../core/services/event.service";
import { Store } from "@ngrx/store";
// import { RootReducerState } from 'src/app/store';

@Component({
  selector: "app-rightsidebar",
  templateUrl: "./rightsidebar.component.html",
  styleUrls: ["./rightsidebar.component.scss"],
})

/**
 * Rightsidebar component
 */
export class RightsidebarComponent implements OnInit {
  isVisible: string;
  attribute: string;
  width: string;
  mode: string;
  topbar: string;
  theme: string;
  layoutSize: string;
  sidebar: string;
  constructor(private eventService: EventService) {}

  ngOnInit() {
    this.attribute = "";
    this.theme = "vertical";
    this.topbar = "dark";
    this.sidebar = "dark";
    this.layoutSize = "fluid";
    /**
     * horizontal-vertical layput set
     */
    this.attribute = document.body.getAttribute("data-layout");
    const vertical = document.getElementById("is-layout");
    if (vertical != null) {
      vertical.setAttribute("checked", "true");
    }
    if (this.attribute == "horizontal") {
      vertical.removeAttribute("checked");
    }
  }

  /**
   * Hide the sidebar
   */
  public hide() {
    document.body.classList.remove("right-bar-enabled");
  }

  /**
   * Change Topbar
   */
  changeTopbar(topbar: string) {
    this.topbar = topbar;
    this.eventService.broadcast("changeTopbar", topbar);
  }

  // toggle button of layout mode
  toggleLayout() {
    this.theme = this.theme === "vertical" ? "horizontal" : "vertical";
    this.changeLayout(this.theme);
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layoutMode: string) {
    this.theme = layoutMode;
  }

  changeWidth(layoutWidth: any) {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 0);
  }
  // sidebar
  changeSidebartype(sidebarMode: any) {}

  changeMode(mode: string) {
    if (mode == "light") {
      document.documentElement.setAttribute("data-topbar", "dark");
    } else {
      document.documentElement.setAttribute("data-topbar", mode);
    }
  }
}
